// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-YuX","col":"styles_col__8ee11"};